import { render, staticRenderFns } from "./PasoTresInvitaciones.vue?vue&type=template&id=965a16b4"
import script from "./PasoTresInvitaciones.vue?vue&type=script&lang=js"
export * from "./PasoTresInvitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports